import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "l-footer" }
const _hoisted_2 = { class: "l-footer__inner" }
const _hoisted_3 = { class: "u-pcOnly" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "株式会社フロムページ 夢ナビ編集部", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "u-spOnly" }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("株式会社フロムページ 夢ナビ編集部"),
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createTextVNode(" copyright(c) Frompage Co.,Ltd. All Rights Reserved")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("address", null, [
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createTextVNode(" copyright(c) 2008 - " + _toDisplayString(_ctx.thisYear) + " Frompage Co.,Ltd. All Rights Reserved", 1)
        ]),
        _hoisted_5
      ])
    ])
  ]))
}